import { getToken, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"

export const getSalesInvoiceOtherSlip = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_other_payments/get_slip",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const createSalesInvoiceOtherPayment = async (data, items) => {
  try {
    const formData = new FormData()
    data.attachments.map((file) => {
      formData.append(`attachments[]`, file)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("payment_date", data.payment_date)
    formData.append("customer_id", data.customer_id)
    formData.append("transaction_type", data.transaction_type)
    formData.append("amount", data.amount)
    formData.append("transaction_no", data.transaction_no)
    formData.append("payee", data.payee)
    formData.append("acknowledged_by", data.acknowledged_by)
    formData.append("particulars", data.particulars ? data.particulars : "")
    formData.append("commission", data.commission ? data.commission : 0.0)
    // formData.append("total_sales", data.total_sales);
    // formData.append("vat_sales", data.vat_sales);
    // formData.append("vat", data.vat);
    // formData.append("withholding_tax", data.withholding_tax);
    // formData.append("wht_percentage", data.wht_percentage);
    // formData.append("grand_total", data.grand_total);

    formData.append("withholding_tax_total", data.withholding_tax_total)
    formData.append("total_amount", data.total_amount)
    formData.append("subtotal", data.subtotal)
    formData.append("total_others", data.total_others)
    formData.append("grand_total", data.grand_total)

    items.map((item) => {
      formData.append(`sales_invoice_ids[]`, item.sales_invoice_id)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_other_payments/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const updateSalesInvoiceOtherPayment = async (data, items) => {
  try {
    const formData = new FormData()
    data.attachments.map((file, index) => {
      formData.append(`attachments[]`, file)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("sales_invoice_other_slip_id", data.id)
    formData.append("payment_date", data.payment_date)
    formData.append("customer_id", data.customer_id)
    formData.append("amount", data.amount)
    formData.append("transaction_type", data.transaction_type)
    formData.append("transaction_no", data.transaction_no)
    formData.append("payee", data.payee)
    formData.append("acknowledged_by", data.acknowledged_by)
    formData.append("particulars", data.particulars ? data.particulars : "")
    formData.append("commission", data.commission ? data.commission : 0.0)
    // formData.append("total_sales", data.total_sales);
    // formData.append("vat_sales", data.vat_sales);
    // formData.append("vat", data.vat);
    // formData.append("withholding_tax", data.withholding_tax);
    // formData.append("wht_percentage", data.wht_percentage);
    // formData.append("grand_total", data.grand_total);

    formData.append("withholding_tax_total", data.withholding_tax_total)
    formData.append("total_amount", data.total_amount)
    formData.append("subtotal", data.subtotal)
    formData.append("total_others", data.total_others)
    formData.append("grand_total", data.grand_total)

    items.map((item) => {
      formData.append(`sales_invoice_ids[]`, item.sales_invoice_id)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_other_payments/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const deleteSalesInvoiceOtherPayment = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      sales_invoice_other_slip_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales_invoice_other_payments/delete_slip",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}
